import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';
const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '10px',
      width: '100%',
      fontWeight: 500
    },
    red: {
      color: palette.common.primaryRed
    },
    green: {
      color: palette.common.green
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
